/*
  A bit of info. Do not delete.

  This is a "wrapper" for the feature flags. This is called in the main.js file
  to initialize the feature flags, in pageDefinition.js to check if a route
  should be enabled or not (it's kind of a weird hack, read below) and in the
  index.js files of each module that have feature flags to check if a menu item
  should be enabled or not.

  - The feature flags are stored in the local storage instead of a store,
    because the store is not accessible at some places in the code (because it
    is accessed through the Vue instance [this, this.$store].
  - This file uses axiosWebApiInstance to do its http call because, like for
    the store, this._vm.$cqrsGet / this.$webApi.get are not accessible in some
    places in the code.
  - Before you mention the getCurrentInstance() method from the vue package, I
    tried it. I was able to access the store, but not the http methods listed
    above.
  - I tried lots of things and of all the things I tried, this was the one that
    was the fastest to execute. Using the store would add some delays in the
    UI. For example: if the companies feature was disabled, the menu would be
    shown in the UI for a split second before being removed. Furthermore, the
    route would still work, and when I would try to prevent the route from
    being accessed, I would run into the instance / http methods / store
    problem.
  - For the route hack: in Vue3 you can remove routes dynamically, which is
    what is done. In Vue2, you cannot remove routes dynamically, so you're
    stuck with the route being there. The way I found to prevent the user from
    going through the route was to use that neat prop in the route definition
    called beforeEnter (check pageDefinition.js or
    https://v3.router.vuejs.org/guide/advanced/navigation-guards.html#per-route-guard).
  
  Do not delete this or you're 바보.
  Aub. (2024-08-07)

*/
import {axiosWebApiInstance} from '@/app/shared/services/http-client/webApi.axios';
const get = axiosWebApiInstance.get;

export default {
  init: async () => {
    const response = await get("core/featureFlags/findAll");
    const featureFlags = response.data.model;
    window.localStorage.setItem("featureFlags", JSON.stringify(featureFlags));
  },
  isEnabled: (flagName) => {
    if (!flagName || flagName === "") return true;
    
    const featureFlags = JSON.parse(window.localStorage.getItem("featureFlags"));
    if (!featureFlags || featureFlags.length === 0) {
      console.error("Feature flags not found, cannot check if flag is enabled. Was init() called?");
      return false;
    }

    const featureFlag = featureFlags.find((x) => x.name === flagName);
    if (!featureFlag) {
      console.warn(`Feature flag ${flagName} not found, assuming it is enabled.`);
      return true;
    }

    return featureFlag.enabled;
  }
}